import { render, staticRenderFns } from "./horizontal-menu-linkage.vue?vue&type=template&id=1d2379b2&scoped=true&"
import script from "./horizontal-menu-linkage.vue?vue&type=script&lang=js&"
export * from "./horizontal-menu-linkage.vue?vue&type=script&lang=js&"
import style0 from "./horizontal-menu-linkage.vue?vue&type=style&index=0&id=1d2379b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2379b2",
  null
  
)

export default component.exports